module.exports = __webpack_public_path__ + "static/media/human-advantage-checkmark.b8cd6632.svg";